import Vue from 'vue'
import VueRouter from 'vue-router'
import articleDetail from '../views/articleDetail.vue'
import { isPC } from '../utils/utils'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'articleDetail',
    component: articleDetail,
    meta: {
      title: '',
      keepAlive: true,
      savePosition: true
    }
  },
  {
    path: '/article/:id/',
    name: 'articleDetailByTag',
    component: articleDetail,
    meta: {
      title: '',
      keepAlive: true,
      savePosition: true
    }
  },
  {
    path: '/articleDetailMxp',
    name: 'articleDetail',
    component: articleDetail,
    meta: {
      title: '',
      keepAlive: true,
      savePosition: true
    }
  },
  {
    path: '/writeComment',
    name: 'writeComment',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "writeComment" */ '../views/writeComment.vue'),
    meta: {
      title: '发表评论',
      keepAlive: true,
      savePosition: true
    }
  },
  {
    path: '/articleListByTag/:id/:keywords/:appKeys/',
    name: 'articleListByTag',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "articleListByTag" */ '../views/articleListByTag.vue'),
    meta: {
      title: '消息标签',
      keepAlive: true,
      savePosition: true
    }
  },
  {
    path: '/articlePreview',
    name: 'articlePreview',
    component: () => import(/* webpackChunkName: "articlePreview" */ '../views/articlePreview.vue'),
    meta: {
      title: '文章预览',
      keepAlive: false,
      savePosition: true
    }
  },
  {
    path: '/articleDelete',
    name: 'articleDelete',
    component: () => import(/* webpackChunkName: "articleDelete" */ '../views/articleDelete.vue'),
    meta: {
      title: '出错了',
      keepAlive: true,
      savePosition: true
    }
  },
  {
    path: '/news/:id/:keywords/:appKeys/',
    name: 'news',
    component: () => import(/* webpackChunkName: "news" */ '../views/news.vue'),
    meta: {
      title: '新闻',
      keepAlive: true,
      savePosition: true
    }
  },
  {
    path: '/content/detail',
    name: '资讯详情',
    component: () => import(/* webpackChunkName: "contentDetail" */ '../views/contentDetail.vue'),
    meta: {
      title: '',
      keepAlive: true,
      savePosition: true
    }
  },
  {
    path: '/content/preview',
    name: '资讯预览',
    component: () => import(/* webpackChunkName: "contentDetail" */ '../views/contentPreview.vue'),
    meta: {
      title: '资讯预览',
      keepAlive: false,
      savePosition: true
    }
  },
  {
    path: '/materialListByTag/:id/:keywords/',
    name: '素材标签',
    component: () => import(/* webpackChunkName: "contentDetail" */ '../views/materialListByTag.vue'),
    meta: {
      title: '素材标签',
      keepAlive: true,
      savePosition: true
    }
  },
  {
    path: '/content/preview/:id/',
    name: 'content_preview',
    component: () => import(/* webpackChunkName: "contentDetail" */ '../views/contentPreview.vue'),
    meta: {
      title: '资讯预览',
      keepAlive: false,
      savePosition: true
    }
  },
  {
    path: '/error',
    name: 'error',
    component: () => import(/* webpackChunkName: "error" */ '../views/error.vue'),
    meta: {
      title: '出错啦',
      keepAlive: false,
      savePosition: true
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name === 'news' && !isPC()) {
    next(`/articleListByTag/${to.params.id}/${to.params.keywords}/${to.params.appKeys}`)
  } else if (to.name === 'articleListByTag' && isPC()) {
    next(`/news/${to.params.id}/${to.params.keywords}/${to.params.appKeys}`)
  } else {
    next()
  }
})

export default router
